import React from 'react';
import { useAuth } from '../hooks/useAuth';
import LanguageSelector from './LanguageSelector';

interface GlobalHeaderProps {
  onMobileMenuToggle?: () => void;
}

const GlobalHeader: React.FC<GlobalHeaderProps> = ({ onMobileMenuToggle }) => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-primary-900 border-b border-primary-700 px-4 md:px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3 md:space-x-4">
          {/* Mobile Menu Toggle Button */}
          <button
            onClick={onMobileMenuToggle}
            className="md:hidden p-2 text-primary-300 hover:text-white hover:bg-primary-800 rounded-lg transition-colors"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          <h1 className="text-lg md:text-xl font-bold text-white">Comex</h1>
          {user && (
            <span className="hidden md:inline-block text-sm text-primary-300">
              Welcome, {user.name}
            </span>
          )}
        </div>

        <div className="flex items-center space-x-2 md:space-x-4">
          <LanguageSelector />

          {user && (
            <div className="flex items-center space-x-2 md:space-x-3">
              <span className="hidden md:inline-block text-sm text-primary-200 capitalize">
                {user.role}
              </span>
              <button
                onClick={logout}
                className="px-3 py-1.5 md:px-3 md:py-1 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                <span className="hidden md:inline">Logout</span>
                <svg className="w-4 h-4 md:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default GlobalHeader;
